import { render, staticRenderFns } from "./CatalogLogs.vue?vue&type=template&id=5856fc23"
import script from "./CatalogLogs.vue?vue&type=script&lang=js"
export * from "./CatalogLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports